import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Tooltip } from 'antd';
import clsx from 'clsx';

import {
	actionGetRolesRights,
	actionDeleteRight,
} from '../../redux/action/accessRights/actionRoles';
import { actionAddRight } from '../../redux/action/accessRights/actionRoles';
import { AppDispatch } from '../../redux/reducer/store';

import Blackout from '../custom/blackout/blackout';
import EditClaimDescriptionModal from '../editClaimDescriptionModal/editClaimDescriptionModal';

import { ReactComponent as DirectionIcon } from '../../assets/icons/direction.svg';
import { ReactComponent as QuestionIcon } from '../../assets/icons/question.svg';
import { ReactComponent as EditIcon } from '../../assets/icons/edit.svg';
import Close from '../../assets/icons/close.svg';

import styles from './rolesModal.module.scss';
import { IUserOptions } from '../../types/interfaces';

// const desktopOptions = [
//   { value: "default", label: "Демонстрационный" },
// ];

// const chartsOptions = [
//   { value: 'visit', label: 'Визиты (план/факт)' },
//   { value: 'oss', label: 'OSS' },
//   { value: 'mediumFace', label: 'Средний фейсинг' },
// ];

interface IModalOptions {
	claims: number;
	title: string;
	onClose: () => void;
	id: any;
};

interface IClaimOptions {
	description: string;
	role: { id: number; name: string };
};

const RolesModal: FC<IModalOptions> = ({ onClose, title, id }) => {
	const dispatch = useDispatch<AppDispatch>();
	const { roleRights, allRolesRights } = useSelector(
		(state: any) => state.roles.roles
	);
	const { claims } = useSelector((state: IUserOptions) => state.user.user.data);

	const [selectedUsedRoles, setSelectedUsedRoles] = useState<number[]>([]);
	const [selectedAllRoles, setSelectedAllRoles] = useState<number[]>([]);
	const [usedRolesSearch, setUsedRolesSearch] = useState<string>('');
	const [allRolesSearch, setAllRolesSearch] = useState<string>('');
	const [isEditOpen, setIsEditOpen] = useState<boolean>(false);
	const [currentElem, setCurrentElem] = useState<IClaimOptions | null>(null);

	const filteredUsedRoles =
		roleRights &&
		roleRights?.filter((option: IClaimOptions) =>
			option?.role?.name
				?.toLowerCase()
				?.includes(usedRolesSearch?.toLowerCase())
		);

	const filteredAllRoles =
		allRolesRights &&
		allRolesRights?.filter((option: IClaimOptions) =>
			option?.role?.name?.toLowerCase()?.includes(allRolesSearch?.toLowerCase())
		);

	useEffect(() => {
		dispatch(actionGetRolesRights(id));
	}, [dispatch, id]);

	const handleAllRoleClick = (roleId: number) => {
		if (selectedAllRoles.includes(roleId)) {
			setSelectedAllRoles(selectedAllRoles.filter(id => id !== roleId));
		} else {
			setSelectedAllRoles([...selectedAllRoles, roleId]);
		}
	};

	const handleUsedRoleClick = (roleId: number) => {
		if (selectedUsedRoles.includes(roleId)) {
			setSelectedUsedRoles(selectedUsedRoles.filter(id => id !== roleId));
		} else {
			setSelectedUsedRoles([...selectedUsedRoles, roleId]);
		}
	};

	const handleAddSelectedRoles = () => {
		if (selectedAllRoles.length > 0) {
			const filteredRoles = allRolesRights
				.filter((roleObj: IClaimOptions) => selectedAllRoles.includes(roleObj.role.id))
				.map((elem: IClaimOptions) => elem.role);

			dispatch(actionAddRight(id, filteredRoles));
			setSelectedAllRoles([]);
		}
	};

	const handleDeleteSelectedRoles = () => {
		if (selectedUsedRoles.length > 0) {
			const filteredRoles = roleRights
				.filter((roleObj: IClaimOptions) => selectedUsedRoles.includes(roleObj.role.id))
				.map((elem: IClaimOptions) => elem.role);
			dispatch(actionDeleteRight(id, filteredRoles));
			setSelectedUsedRoles([]);
		}
	};

	const handleClickTooltip = (event: React.MouseEvent) => {
		event.stopPropagation();
	};

	const handleEditClaimDescription = (elem: IClaimOptions) => {
		setCurrentElem(elem);
		setIsEditOpen(!isEditOpen);
	};

	return (
		<>
			<Blackout onClose={onClose}>
				<div
					onClick={handleClickTooltip}
					className={styles.modal}
				>
					<div className={styles.title__block}>
						<span>{title}</span>
						<img
							style={{ cursor: 'pointer' }}
							onClick={onClose}
							src={Close}
							alt='close'
						/>
					</div>
					{/* <div>
						<div className="client__settings_filterBlock">
            <span>Рабочий стол (по умолчанию)</span>
            <div className="settings__filterBlock_children">
              <div className='multiselect__filter_block' style={{ width: "100%" }}>
                <CustomMultiSelect
                  setLoading={()=>{}}
                  inputValues={{}}
                  options={desktopOptions}
                  isShowPlaceholder={true}
                  pageName='mapTypes1'
                  placeholder='Рабочий стол'
                  name='mapModes'
                  limit={0}
                  reducer={()=>{}}
                  resetPages={()=>{}}
                  action={()=>{}}
                />
              </div>
            </div>
          </div>
          <div className="client__settings_filterBlock">
            <span>Диаграммы</span>
            <div className="settings__filterBlock_children">
              <div className='multiselect__filter_block' style={{ width: "100%" }}>
                <CustomMultiSelect
                  setLoading={()=>{}}
                  inputValues={{}}
                  options={chartsOptions}
                  isShowPlaceholder={true}
                  pageName='mapTypes1'
                  placeholder='Тип'
                  name='mapModes'
                  limit={0}
                  reducer={()=>{}}
                  resetPages={()=>{}}
                  action={()=>{}}
                />
              </div>
            </div>
          </div>
					</div> */}
					<div className={styles.roles__block}>
						<div className={styles.button__block}>
							<div className={styles.roles__table}>
								<div className={styles.roles__title_block}>
									<span>Доступные права</span>
								</div>
								<input
									onChange={e => setAllRolesSearch(e?.target?.value)}
									className={styles.roles__search}
									placeholder='Поиск...'
									type='text'
								/>
								<div className={styles.roles__list}>
									{filteredAllRoles &&
										filteredAllRoles.map((elem: IClaimOptions, index: number) => (
											<div
												onClick={() => handleAllRoleClick(elem.role.id)}
												className={clsx(
													styles.role__elem,
													selectedAllRoles.includes(elem.role.id) &&
													styles.active__role
												)}
												key={index}
											>
												<span>{elem.role.name}</span>

												<Tooltip
													title={
														<div
															className={styles.tooltip__block}
															onClick={handleClickTooltip}
														>
															<div
																className={styles.tooltip__text}
																dangerouslySetInnerHTML={{
																	__html: elem.description,
																}}
															/>
															{(claims.includes('admin') ||
																claims.includes('role:claim:change')) && (
																	<EditIcon
																		onClick={() =>
																			handleEditClaimDescription(elem)
																		}
																		className={styles.edit__icon}
																	/>
																)}
														</div>
													}
													color={'var(--main-color)'}
													placement='right'
												>
													<QuestionIcon
														className={clsx(
															styles.role__elem_icon,
															selectedAllRoles.includes(elem.role.id) &&
															styles.active__role_icon
														)}
													/>
												</Tooltip>
											</div>
										))}
								</div>
							</div>
							<button
								disabled={
									!(
										claims.includes('admin') ||
										claims.includes('role:claim:change')
									)
								}
								className={clsx(
									styles.add__table_disabledButton,
									selectedAllRoles.length > 0 &&
									(claims.includes('admin') ||
										claims.includes('role:claim:change')) &&
									styles.add__table_activeButton
								)}
								onClick={handleAddSelectedRoles}
							>
								Добавить выбранные
								<DirectionIcon className={styles.add__direction_icon} />
							</button>
						</div>

						<div className={styles.button__block}>
							<div className={styles.roles__table}>
								<div className={styles.roles__title_block}>
									<span>Назначенные права</span>
								</div>
								<input
									onChange={e => setUsedRolesSearch(e?.target?.value)}
									className={styles.roles__search}
									placeholder='Поиск...'
									type='text'
								/>
								<div className={styles.roles__list}>
									{filteredUsedRoles &&
										filteredUsedRoles.map((elem: IClaimOptions, index: number) => (
											<div
												onClick={() => handleUsedRoleClick(elem.role.id)}
												className={clsx(
													styles.role__elem,
													selectedUsedRoles.includes(elem.role.id) &&
													styles.active__role
												)}
												key={index}
											>
												<span>{elem.role.name}</span>
												<Tooltip
													title={
														<div
															className={styles.tooltip__block}
															onClick={handleClickTooltip}
														>
															<div
																className={styles.tooltip__text}
																dangerouslySetInnerHTML={{
																	__html: elem.description,
																}}
															/>

															{(claims.includes('admin') ||
																claims.includes('role:claim:change')) && (
																	<EditIcon
																		onClick={() =>
																			handleEditClaimDescription(elem)
																		}
																		className={styles.edit__icon}
																	/>
																)}
														</div>
													}
													color={'var(--main-color)'}
													placement='right'
												>
													<QuestionIcon
														className={clsx(
															styles.role__elem_icon,
															selectedUsedRoles.includes(elem.role.id) &&
															styles.active__role_icon
														)}
													/>
												</Tooltip>
											</div>
										))}
									{!filteredUsedRoles && (
										<span className={styles.empty__list_text}>
											Нет назначенных прав
										</span>
									)}
								</div>
							</div>
							<button
								disabled={
									!(
										claims.includes('admin') ||
										claims.includes('role:claim:change')
									)
								}
								className={clsx(
									styles.delete__table_disabledButton,
									selectedUsedRoles.length > 0 &&
									(claims.includes('admin') ||
										claims.includes('role:claim:change')) &&
									styles.delete__table_activeButton
								)}
								onClick={handleDeleteSelectedRoles}
							>
								<DirectionIcon className={styles.delete__direction_icon} />
								Удалить выбранные
							</button>
						</div>
					</div>
				</div>
			</Blackout>
			{(isEditOpen && currentElem) && (
				<EditClaimDescriptionModal
					setState={setIsEditOpen}
					state={isEditOpen}
					id={id}
					elem={currentElem}
				/>
			)}
		</>
	);
};

export default RolesModal;
